import type { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import ExperiencePage from '../pages/experience/page';
import ExperienceDetailsPage from '../pages/experience/details';
import GrouptourPage from '../pages/group-tours/page';
import ToursViewPage from '../pages/tours-view/page';
import CartPage from '../pages/cart/page';
import AsiaPage from '../pages/regional/asia/page';
import AfricaPage from '../pages/regional/africa/page';
import NorthAmericaPage from '../pages/regional/north-america/page';
import SouthAmericaPage from '../pages/regional/south-america/page';
import EuropePage from '../pages/regional/europe/page';
import AustraliaPage from '../pages/regional/australia/page';
import AntarcticaPage from '../pages/regional/antarctica/page';
import CruisesPage from '../pages/cruises/page';
import AdventurePage from '../pages/adventure/page';
import StaysPage from '../pages/stays/page';
import ContactPage from '../pages/contact/page';
import AdminIndex from '../admin';
import { AdminAuthProvider } from '../admin/AuthProvider';
import Login from '../admin/Login';
import Dashboard from '../admin/dashboard/dashboard';
import Contacts from '../admin/contacts/contacts';
// Removed unused admin pages: Deals, Activities, Tasks, Attendance
import Users from '../admin/users/users';
import AdminGroupTours from '../admin/group-tours/admin-group-tours';
import AdminExperiences from '../admin/experience/admin-experience';
import Permissions from '../admin/permissions/permissions';
import ProtectedRoute from '../admin/ProtectedRoute';
import NotFoundPage from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/group-tours',
    element: <GrouptourPage />,
  },
  {
    path: '/group-tours/details',
    element: <ToursViewPage />,
  },
  {
    path: '/experience',
    element: <ExperiencePage />,
  },
  {
    path: '/experience/details',
    element: <ExperienceDetailsPage />,
  },
  {
    path: '/cart',
    element: <CartPage />,
  },
  {
    path: '/regional/asia',
    element: <AsiaPage />,
  },
  {
    path: '/regional/africa',
    element: <AfricaPage />,
  },
  {
    path: '/regional/north-america',
    element: <NorthAmericaPage />,
  },
  {
    path: '/regional/south-america',
    element: <SouthAmericaPage />,
  },
  {
    path: '/regional/europe',
    element: <EuropePage />,
  },
  {
    path: '/regional/australia',
    element: <AustraliaPage />,
  },
  {
    path: '/regional/antarctica',
    element: <AntarcticaPage />,
  },
  {
    path: '/cruises',
    element: <CruisesPage />,
  },
  {
    path: '/adventure',
    element: <AdventurePage />,
  },
  {
    path: '/book-villa-online',
    element: <StaysPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/admin',
    element: (
      <AdminAuthProvider>
        <AdminIndex />
      </AdminAuthProvider>
    ),
    children: [
      { path: 'login', element: <Login /> },
      { path: 'dashboard', element: <ProtectedRoute><Dashboard /></ProtectedRoute> },
      { path: 'contacts', element: <ProtectedRoute><Contacts /></ProtectedRoute> },
      // Removed routes for deals, activities, tasks, attendance
      { path: 'users', element: <ProtectedRoute><Users /></ProtectedRoute> },
      { path: 'group-tours', element: <ProtectedRoute><AdminGroupTours /></ProtectedRoute> },
      { path: 'experiences', element: <ProtectedRoute><AdminExperiences /></ProtectedRoute> },
      { path: 'permissions', element: <ProtectedRoute><Permissions /></ProtectedRoute> },
      { index: true, element: <Login /> },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;